import {Component, EventEmitter, Input, Output} from '@angular/core';
import {ContentComponent} from "../../../shared/elements/content/content.component";
import {IconBadgeComponent} from "../../../shared/elements/icon-badge/icon-badge.component";
import {TooltipComponent} from "../../../shared/elements/tooltip/tooltip.component";
import {TranslatePipe} from "../../../shared/pipes/translate.pipe";
import {TYPE} from "../../../shared/types/types";


@Component({
    selector: 'app-item-documents-folder',
    imports: [
        ContentComponent,
        IconBadgeComponent,
        TooltipComponent,
        TranslatePipe
    ],
    templateUrl: './item-documents-folder.component.html',
    styleUrl: './item-documents-folder.component.scss'
})
export class ItemDocumentsFolderComponent {
  @Input() public folder: TYPE.Folder | null = null;
  @Output() public  folderSelected: EventEmitter<TYPE.Folder> = new EventEmitter<TYPE.Folder>();

  public selectFolder(): void {
    if (this.folder) {
      this.folderSelected.emit(this.folder);
    }
  }
}
